/*
 * Wizard steps action types
 */

let numberOfUsers = 1;

export const CREATE_USER = 'CREATE_USER';
export const INCREASE_NUMBER_OF_USERS = 'INCREASE_NUMBER_OF_USERS';
export const DECREASE_NUMBER_OF_USERS = 'DECREASE_NUMBER_OF_USERS';
export const SET_NUMBER_OF_USERS = 'SET_NUMBER_OF_USERS';
export const SET_CONTENT_PROVIDER = 'SET_CONTENT_PROVIDER';

export const createUser = (id, userType, minNumberOfUsers, maxNumberOfUsers, _numberOfUsers, amountPerUser, name, unit, dependency, contentProviders) => ({
    type: CREATE_USER,
    id,
    userType,
    minNumberOfUsers,
    maxNumberOfUsers,
    numberOfUsers: (numberOfUsers = _numberOfUsers),
    amountPerUser,
    name,
    unit,
    dependency,
    contentProviders,
    chosenProvider: ''
});

export const setContentProvider = (userType, chosenProvider) => ({
    type: SET_CONTENT_PROVIDER,
    userType,
    chosenProvider,
});
export const setNumberOfUsers = (userType, _numberOfUsers) => ({
    type: SET_NUMBER_OF_USERS,
    userType,
    numberOfUsers: (numberOfUsers =_numberOfUsers),
});

export const increaseNumberOfUsers = (userType) => ({
    type: INCREASE_NUMBER_OF_USERS,
    userType,
    numberOfUsers: numberOfUsers+=1,
});

export const decreaseNumberOfUsers = (userType) => ({
    type: INCREASE_NUMBER_OF_USERS,
    userType,
    numberOfUsers: numberOfUsers-=1,
});
